import { Link, redirect, useLoaderData, useParams } from "react-router-dom";
import HttpRequest from "../../services/Request";
import TournamentComponent from "../../components/Tournament";
import Cookies from "js-cookie";
import BackButton from "../../components/BackButton";

const Tournament = () => {
  const { tournament, isHoc, isHseManager, team } = useLoaderData();
  const params = useParams();

  // Extract scientific source URLs — try top-level field first, then fall back to details array
  let scientificSources = [];
  if (
    Array.isArray(tournament.scientific_source) &&
    tournament.scientific_source.length > 0
  ) {
    scientificSources = tournament.scientific_source;
  } else if (Array.isArray(tournament.details)) {
    scientificSources = tournament.details
      .filter((d) => d.type === "scientific_source" && d.file)
      .map((d) => d.file);
  }

  return (
    <div>
      <BackButton src={"/"} />
      <div className="flex items-center">
        <TournamentComponent tournament={tournament} />
      </div>
      <div className="flex items-center flex-col mt-5">
        {isHseManager && (
          <div className="flex flex-wrap w-[97%]  md:w-[90%] rounded-[15px] mx-auto mt-3 md:mt-0 md:mb-4 bg-white p-2 py-5">
            <Link
              to={`hse-manager/teams`}
              className="w-[80%] md:w-[27%] md:mt-5 text-center p-3 mx-auto shadow mt-3 bg-gray2 text-orange"
            >
              <img
                src="/icons/icon-4.png"
                className="inline me-3 w-[25px] h-[25px]"
              />
              معرفی سرپرست
            </Link>
          </div>
        )}
        {isHoc && (
          <div className="flex flex-wrap w-[97%]  md:w-[90%] rounded-[15px] mx-auto mt-3 md:mt-0 md:mb-4 bg-white p-2 py-5">
            <Link
              to={`team/posts`}
              className="w-[80%] md:w-[27%] md:mt-5 text-center p-3 mx-auto shadow mt-3 bg-gray2 text-orange"
            >
              <img
                src="/icons/icon-4.png"
                className="inline me-3 w-[25px] h-[25px]"
              />
              مدیریت نفرات تیم
            </Link>
            {team.report && (
              <a
                href={team.report}
                target={`_blank`}
                className="w-[80%] md:w-[27%] md:mt-5 text-center p-3 mx-auto shadow mt-3 bg-gray2 text-orange"
              >
                <img
                  src="/icons/report.png"
                  className={`inline me-3 w-[25px] h-[25px]`}
                  alt=""
                />
                <span className="text-[18px]">نتیجه مسابقه تیم</span>
              </a>
            )}
          </div>
        )}
        {tournament.all_users_added && (
          <>
            <div className="flex flex-wrap w-[97%] md:w-[90%] rounded-[15px] mx-auto mt-3 md:mt-0 md:mb-4 bg-white p-2 py-5">
              <a
                href={tournament.description.data}
                className="w-[80%] md:w-[27%] text-center p-3 mx-auto shadow mt-3 bg-gray2 text-orange"
              >
                <img
                  src="/icons/icon-1.png"
                  className="inline me-3 w-[25px] h-[25px]"
                />
                آیین نامه المپیاد
              </a>

              <Link
                to={`/tournament/${params.id}/steps`}
                className="w-[80%] md:w-[27%] text-center p-3 mx-auto shadow mt-3 bg-gray2 text-orange"
              >
                <img
                  src="/icons/icon-2.png"
                  className="inline me-3 w-[25px] h-[25px]"
                />
                شرح مسابقات
              </Link>

              {tournament.quiz && (
                <a
                  href={tournament.quiz}
                  className="w-[80%] md:w-[27%] text-center p-3 mx-auto shadow mt-3 bg-gray2 text-orange"
                >
                  <img
                    src="/icons/icons8-quiz-100.png"
                    className="inline me-3 w-[25px] h-[25px]"
                  />
                  آزمون آزمایشی
                </a>
              )}
            </div>

            {scientificSources.length > 0 && (
              <div className="flex items-center mt-2">
                <div className="flex flex-wrap w-[97%] md:w-[90%] rounded-[15px] mx-auto mt-3 md:mt-0 md:mb-4 bg-white p-2 py-5">
                  <div className="w-full text-center mb-2">
                    <span className="text-[20px] font-bold text-orange">
                      منابع آزمون علمی
                    </span>
                  </div>

                  {scientificSources.map((source, i) => {
                    const fileUrl =
                      typeof source === "string"
                        ? source
                        : source?.url || source?.file_url || source?.file || "";

                    const fileName =
                      typeof source === "object"
                        ? source?.name || source?.file_name || ""
                        : "";

                    if (!fileUrl) return null;

                    return (
                      <a
                        key={i}
                        href={fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-[80%] md:w-[27%] text-center p-3 mx-auto shadow mt-3 bg-gray2 text-orange"
                      >
                        <img
                          src="/icons/icon-3.png"
                          className="inline me-3 w-[25px] h-[25px]"
                          alt=""
                        />

                        <span className="text-[18px]">
                          {fileName || `منبع آزمون علمی ${i + 1}`}
                        </span>
                      </a>
                    );
                  })}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Tournament;

export async function TournamentPageLoader({ params }) {
  let data = [];
  try {
    await HttpRequest(
      `${process.env.REACT_APP_DOMAIN}/user/tournament/${params.id}`,
      (res) => {
        data = res.data;
      },
      "get",
      [],
      (err) => {
        let error = new Error();
        error.status = err.response.status;
        throw error;
      },
    );
  } catch (err) {
    if (err.status === 401) {
      Cookies.remove("access_token");
      return redirect("/login");
    }
  }
  return data;
}
